import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "notice"];
  static values = {
    attribute: String,
    text: String,
  };

  copy() {
    let toCopy = "";
    if (this.attributeValue) {
      toCopy = this.sourceTarget.getAttribute(this.attributeValue);
    } else if (this.textValue) {
      toCopy = this.textValue;
    } else {
      toCopy = this.sourceTarget.textContent;
    }

    navigator.clipboard.writeText(toCopy).then(
      () => {
        /* clipboard successfully set */
        console.log(toCopy);
        this.showNotice("Copied!");
      },
      () => {
        /* clipboard write failed */
        console.log(toCopy);
        this.showNotice("Copy failed!");
      }
    );
  }

  showNotice(notice) {
    if (this.hasNoticeTarget) {
      this.noticeTarget.textContent = notice;
      setTimeout(() => {
        this.noticeTarget.textContent = "";
      }, 1000);
    }
  }
}
